export function generateList(optionsArr, dilineator = " | ") {
    let returnArr = [];
    for (let i = 0; i < optionsArr.length; i++) {
        if (optionsArr[i].value) {
            if (optionsArr[i].order === "reverse") {
                returnArr.push(`${optionsArr[i].value}${optionsArr[i].label}`);
            }
            else {
                returnArr.push(`${optionsArr[i].label}${optionsArr[i].value}`);
            }
        }
    }
    return returnArr.join(dilineator);
}
